import { createSlice } from '@reduxjs/toolkit';
// utils
import apiUser from '../../api/user';
//import { JanusHelper, plugins, Janus } from 'janus-helper'
import Janus from 'janus-gateway'
import $ from 'jquery'
const initialState = {
    registerUsername: null,
    doVideoCall: null,
    doHangup: null,
    doDecline: null,
    doAnswer: null,
    toggleMute: null,
    toggleHold: null,
    transfer: null,
    videoCalling: false,
    status: null,
    infoContact: {},
    outGoingVideoCall: false,
    incomingVideoCall: false,
    answered: false,
    isConnect: false,
    message: "",
    isHold: false,
    isMuted: false,
    isTransfer: false,
    sendDtmf: null,
    msgError: "",
    doCloseCall: null,
    doShareScreen: null,
    is_share_screen: false,
    toggleVideo: null,
    isMutedVideo: false,
};
//
// name : teen store quan li

const slice = createSlice({
    name: 'janus_video',
    initialState,
    reducers: {
        // START LOADING
        startLoading(state) {
            state.isLoading = true;
        },
        // HAS ERROR
        hasError(state, action) {
            state.isLoading = false;
            state.message = action.payload;
        },
        initializeJanus(state, action) {
            state.registerUsername = action.payload.registerUsername
            state.doVideoCall = action.payload.doCall;
            state.doAnswer = action.payload.doAnswer;
            state.doHangup = action.payload.doHangup;
            state.doCloseCall = action.payload.doCloseCall;
            state.toggleMute = action.payload.toggleMute;
            state.doShareScreen = action.payload.doShareScreen;
            state.toggleVideo = action.payload.toggleVideo;
        },
        statusAnswered(state, action) {
            state.answered = true;
            state.incomingVideoCall = false;
        },
        statusRegistered(state, action) {
            state.isConnect = true;
        },
        statusIncomingVideoCall(state, action) {
            state.videoCalling = true;
            state.outGoingVideoCall = false;
            state.incomingVideoCall = true;
            state.isMuted = false;

            state.infoContact = { full_name: action.payload.full_name };
            // const uri = action.payload.name;
            // const regex = /sip:(\d+)@/; // matches "sip:", followed by one or more digits (\d+), followed by "@"
            // const match = uri.match(regex);
            // if (match) {
            //     const number = match[1]; // the first capturing group (\d+) contains the number
            //     state.infoContact = { name: "", phone: number };

            // } else {
            //     state.infoContact = { name: "", phone: "Không xác định" };
            // }

        },
        statusHangup(state, action) {
            state.answered = false;
            state.videoCalling = false;
            state.infoContact = null;
            state.outGoingVideoCall = false;
            state.incomingVideoCall = false;
        },
        statusCalling(state, action) {
            state.videoCalling = action.payload.statusCall;
            state.outGoingVideoCall = action.payload.outGoingVideoCall;
            state.incomingVideoCall = action.payload.incomingVideoCall;
        },
        statusDecline(state, action) {
            state.calling = false;
            state.infoContact = null;
            state.outGoingVideoCall = false;
            state.incomingVideoCall = false;
            state.answered = false;
        },
        statusAnswer(state, action) {
            state.answered = true;
            state.incomingVideoCall = false;
            state.isMuted = false;
        },
        statusHolding(state, action) {
            state.isHold = action.payload.holding
        },
        statusMute(state, action) {
            state.isMuted = action.payload.muted
        },
        statusTransferring(state, action) {
            state.isTransfer = action.payload.transferring
        },
        statusError(state, action) {
            console.log(action.payload.msgError)
            state.msgError = action.payload.msgError;
            // state.calling = false;
            // state.infoContact = null;
            // state.outGoingVideoCall = false;
            // state.incomingVideoCall = false;
            // state.answered = false;
            // state.videoCalling =false;
        },
        statusOnCloseCallVideo(state, action) {
            state.msgError = "";
            state.calling = false;
            state.infoContact = null;
            state.outGoingVideoCall = false;
            state.incomingVideoCall = false;
            state.answered = false;
            state.videoCalling = false;
        },
        statusShareScreen(state, action) {
            state.is_share_screen = action.payload.is_share_screen;
        },
        statusMuteVideo(state, action) {
            state.isMutedVideo = action.payload.muted
        }
    }
});

// Reducer
export default slice.reducer;


export const InitJanusVideo = (registerId) => (dispatch) => {
    console.log(registerId)
    var server = null;
    server= 'https://janus2.voip24h.vn/janus';
    var iceServers = null;
    var janus = null;
    var videocall = null;
    var opaqueId = "videocalltest-" + Janus.randomString(12);

    var localTracks = {}, localVideos = 0,
        remoteTracks = {}, remoteVideos = 0;
    var bitrateTimer = null;
    var spinner = null;

    var audioenabled = false;
    var videoenabled = false;

    var myusername = null;
    var yourusername = null;

    var doSimulcast = (getQueryStringValue("simulcast") === "yes" || getQueryStringValue("simulcast") === "true");
    var simulcastStarted = false;
    var jsepp = null;
    var stream_camera = null;
    function getQueryStringValue(name) {
        name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
        let regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
            results = regex.exec(window.location.search);
        return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
    }
    // Helper to escape XML tags
    function escapeXmlTags(value) {
        if (value) {
            let escapedValue = value.replace(new RegExp('<', 'g'), '&lt');
            escapedValue = escapedValue.replace(new RegExp('>', 'g'), '&gt');
            return escapedValue;
        }
    }
    function registerUsername(registerIdNew) {
        // Try a registration
        // $('#username').attr('disabled', true);
        // $('#register').attr('disabled', true).unbind('click');
        console.log(registerIdNew)
        $('#username').val(registerIdNew)
        let username = registerIdNew;
        if (username === "") {
            //  bootbox.alert("Insert a username to register (e.g., pippo)");
            $('#username').removeAttr('disabled');
            $('#register').removeAttr('disabled').click(registerIdNew);
            return;
        }
        if (/[^a-zA-Z0-9]/.test(username)) {
            //bootbox.alert('Input is not alphanumeric');
            $('#username').removeAttr('disabled').val("");
            $('#register').removeAttr('disabled').click(registerUsername);
            return;
        }
        let register = { request: "register", username: username, test: "test 1" };
        videocall.send({ message: register });
    }
    const doCloseCall = () => {
        dispatch(slice.actions.statusOnCloseCallVideo());
    }
    const getInfoUser = async (user_id) => {
        const res_info_user = await apiUser.find_name_by_id({ user_id });
        return res_info_user?.data?.data
    }
    const doHangup = () => {
        // Hangup a call
        $('#call').attr('disabled', true).unbind('click');
        let hangup = { request: "hangup" };
        videocall.send({ message: hangup });
        videocall.hangup();
        yourusername = null;
        dispatch(slice.actions.statusHangup());
    }
    const doCall = (callFor) => {
        // Call someone
        $('#peer').val(callFor)
        $('#peer').attr('disabled', true);
        $('#call').attr('disabled', true).unbind('click');
        let username = callFor;
        if (username === "") {
            //  bootbox.alert("Insert a username to call (e.g., pluto)");
            $('#peer').removeAttr('disabled');
            $('#call').removeAttr('disabled').click(doCall);
            return;
        }
        if (/[^a-zA-Z0-9]/.test(username)) {
            //bootbox.alert('Input is not alphanumeric');
            $('#peer').removeAttr('disabled').val("");
            $('#call').removeAttr('disabled').click(doCall);
            return;
        }

        // Call this user
        videocall.createOffer(
            {
                // We want bidirectional audio and video, plus data channels
                tracks: [
                    { type: 'audio', capture: true, recv: true },
                    { type: 'video', capture: true, recv: true, simulcast: doSimulcast },
                    { type: 'data' },
                ],
                media: {
                    audioSend: true,
                    audioRecv: true, // We DO want audio
                    videoSend: true,
                    videoRecv: true, // We MAY want video
                },
                success: function (jsep) {

                    Janus.debug("Got SDP!", jsep);
                    let body = { request: "call", username, test: '1232131232132132131' };
                    videocall.send({ message: body, jsep });
                },
                error: function (error) {
                    console.log(error.message)
                    Janus.error("WebRTC error...", error);
                    //  bootbox.alert("WebRTC error... " + error.message);
                }
            }
        );
        dispatch(slice.actions.statusCalling({ statusCall: true, outGoingVideoCall: true, incomingVideoCall: false }));
    }

    const doAnswer = () => {
        videocall.createAnswer(
            {
                jsep: jsepp,
                // We want bidirectional audio and video, if offered,
                // plus data channels too if they were negotiated
                tracks: [
                    { type: 'audio', capture: true, recv: true },
                    { type: 'video', capture: true, recv: true },
                    { type: 'data' },
                ],
                success: function (jsep) {
                    Janus.debug("Got SDP!", jsep);
                    let body = { request: "accept" };
                    videocall.send({ message: body, jsep: jsep });
                    $('#peer').attr('disabled', true);
                    $('#call').removeAttr('disabled').html('Hangup')
                        .removeClass("btn-success").addClass("btn-danger")
                        .unbind('click').click(doHangup);
                },
                error: function (error) {
                    Janus.error("WebRTC error:", error);
                    ///bootbox.alert("WebRTC error... " + error.message);
                }
            }
        );
        dispatch(slice.actions.statusAnswer());
    }
    const doShareScreen = async (is_share_screen) => {
        if (is_share_screen) {
            const newTrack = {
                tracks: [{ replace: true, type: "screen", capture: true, recv: true, simulcast: doSimulcast }]
            }
            videocall.replaceTracks(newTrack);

        } else {
            const newTrack = {
                tracks: [{ replace: true, type: "video", capture: true, recv: true, simulcast: doSimulcast }]
            }
            videocall.replaceTracks(newTrack)

        }
        dispatch(slice.actions.statusShareScreen({ is_share_screen: is_share_screen }));
    }
    const toggleMute = () => {
        // let muted = videocall.isAudioMuted();
        // Janus.log((muted ? "Unmuting" : "Muting") + " local stream...");
        // if (muted) {
        //     videocall.unmuteAudio();
        //     dispatch(slice.actions.statusMute({ muted: false }));
        // } else {
        //     videocall.muteAudio();
        //     dispatch(slice.actions.statusMute({ muted: true }));
        // }
        // muted = videocall.isAudioMuted();
    }
    const toggleVideo = () => {
        // let muted = videocall.isVideoMuted();
        // Janus.log((muted ? "Unmuting" : "Muting") + " local stream...");
        // if (muted) {
        //     videocall.unmuteVideo();
        //     dispatch(slice.actions.statusMuteVideo({ muted: false }));
        // } else {
        //     videocall.muteVideo();
        //     dispatch(slice.actions.statusMuteVideo({ muted: true }));
        // }
    }



    function addSimulcastButtons(temporal) {
        $('#curres').parent().append(
            '<div id="simulcast" class="btn-group-vertical btn-group-vertical-xs pull-right">' +
            '	<div class"row">' +
            '		<div class="btn-group btn-group-xs" style="width: 100%">' +
            '			<button id="sl-2" type="button" class="btn btn-primary" data-toggle="tooltip" title="Switch to higher quality" style="width: 33%">SL 2</button>' +
            '			<button id="sl-1" type="button" class="btn btn-primary" data-toggle="tooltip" title="Switch to normal quality" style="width: 33%">SL 1</button>' +
            '			<button id="sl-0" type="button" class="btn btn-primary" data-toggle="tooltip" title="Switch to lower quality" style="width: 34%">SL 0</button>' +
            '		</div>' +
            '	</div>' +
            '	<div class"row">' +
            '		<div class="btn-group btn-group-xs hide" style="width: 100%">' +
            '			<button id="tl-2" type="button" class="btn btn-primary" data-toggle="tooltip" title="Cap to temporal layer 2" style="width: 34%">TL 2</button>' +
            '			<button id="tl-1" type="button" class="btn btn-primary" data-toggle="tooltip" title="Cap to temporal layer 1" style="width: 33%">TL 1</button>' +
            '			<button id="tl-0" type="button" class="btn btn-primary" data-toggle="tooltip" title="Cap to temporal layer 0" style="width: 33%">TL 0</button>' +
            '		</div>' +
            '	</div>' +
            '</div>');
        if (Janus.webRTCAdapter.browserDetails.browser !== "firefox") {
            // Chromium-based browsers only have two temporal layers
            $('#tl-2').remove();
            $('#tl-1').css('width', '50%');
            $('#tl-0').css('width', '50%');
        }
        // Enable the simulcast selection buttons
        $('#sl-0').removeClass('btn-primary btn-success').addClass('btn-primary')
            .unbind('click').click(function () {
                // toastr..info("Switching simulcast substream, wait for it... (lower quality)", null, { timeOut: 2000 });
                if (!$('#sl-2').hasClass('btn-success'))
                    $('#sl-2').removeClass('btn-primary btn-info').addClass('btn-primary');
                if (!$('#sl-1').hasClass('btn-success'))
                    $('#sl-1').removeClass('btn-primary btn-info').addClass('btn-primary');
                $('#sl-0').removeClass('btn-primary btn-info btn-success').addClass('btn-info');
                videocall.send({ message: { request: "set", substream: 0 } });
            });
        $('#sl-1').removeClass('btn-primary btn-success').addClass('btn-primary')
            .unbind('click').click(function () {
                // toastr..info("Switching simulcast substream, wait for it... (normal quality)", null, { timeOut: 2000 });
                if (!$('#sl-2').hasClass('btn-success'))
                    $('#sl-2').removeClass('btn-primary btn-info').addClass('btn-primary');
                $('#sl-1').removeClass('btn-primary btn-info btn-success').addClass('btn-info');
                if (!$('#sl-0').hasClass('btn-success'))
                    $('#sl-0').removeClass('btn-primary btn-info').addClass('btn-primary');
                videocall.send({ message: { request: "set", substream: 1 } });
            });
        $('#sl-2').removeClass('btn-primary btn-success').addClass('btn-primary')
            .unbind('click').click(function () {
                // toastr..info("Switching simulcast substream, wait for it... (higher quality)", null, { timeOut: 2000 });
                $('#sl-2').removeClass('btn-primary btn-info btn-success').addClass('btn-info');
                if (!$('#sl-1').hasClass('btn-success'))
                    $('#sl-1').removeClass('btn-primary btn-info').addClass('btn-primary');
                if (!$('#sl-0').hasClass('btn-success'))
                    $('#sl-0').removeClass('btn-primary btn-info').addClass('btn-primary');
                videocall.send({ message: { request: "set", substream: 2 } });
            });
        if (!temporal)	// No temporal layer support
            return;
        $('#tl-0').parent().removeClass('hide');
        $('#tl-0').removeClass('btn-primary btn-success').addClass('btn-primary')
            .unbind('click').click(function () {
                // toastr..info("Capping simulcast temporal layer, wait for it... (lowest FPS)", null, { timeOut: 2000 });
                if (!$('#tl-2').hasClass('btn-success'))
                    $('#tl-2').removeClass('btn-primary btn-info').addClass('btn-primary');
                if (!$('#tl-1').hasClass('btn-success'))
                    $('#tl-1').removeClass('btn-primary btn-info').addClass('btn-primary');
                $('#tl-0').removeClass('btn-primary btn-info btn-success').addClass('btn-info');
                videocall.send({ message: { request: "set", temporal: 0 } });
            });
        $('#tl-1').removeClass('btn-primary btn-success').addClass('btn-primary')
            .unbind('click').click(function () {
                // toastr..info("Capping simulcast temporal layer, wait for it... (medium FPS)", null, { timeOut: 2000 });
                if (!$('#tl-2').hasClass('btn-success'))
                    $('#tl-2').removeClass('btn-primary btn-info').addClass('btn-primary');
                $('#tl-1').removeClass('btn-primary btn-info').addClass('btn-info');
                if (!$('#tl-0').hasClass('btn-success'))
                    $('#tl-0').removeClass('btn-primary btn-info').addClass('btn-primary');
                videocall.send({ message: { request: "set", temporal: 1 } });
            });
        $('#tl-2').removeClass('btn-primary btn-success').addClass('btn-primary')
            .unbind('click').click(function () {
                // toastr..info("Capping simulcast temporal layer, wait for it... (highest FPS)", null, { timeOut: 2000 });
                $('#tl-2').removeClass('btn-primary btn-info btn-success').addClass('btn-info');
                if (!$('#tl-1').hasClass('btn-success'))
                    $('#tl-1').removeClass('btn-primary btn-info').addClass('btn-primary');
                if (!$('#tl-0').hasClass('btn-success'))
                    $('#tl-0').removeClass('btn-primary btn-info').addClass('btn-primary');
                videocall.send({ message: { request: "set", temporal: 2 } });
            });
    }

    function updateSimulcastButtons(substream, temporal) {
        // Check the substream
        if (substream === 0) {
            // toastr..success("Switched simulcast substream! (lower quality)", null, { timeOut: 2000 });
            $('#sl-2').removeClass('btn-primary btn-success').addClass('btn-primary');
            $('#sl-1').removeClass('btn-primary btn-success').addClass('btn-primary');
            $('#sl-0').removeClass('btn-primary btn-info btn-success').addClass('btn-success');
        } else if (substream === 1) {
            // toastr..success("Switched simulcast substream! (normal quality)", null, { timeOut: 2000 });
            $('#sl-2').removeClass('btn-primary btn-success').addClass('btn-primary');
            $('#sl-1').removeClass('btn-primary btn-info btn-success').addClass('btn-success');
            $('#sl-0').removeClass('btn-primary btn-success').addClass('btn-primary');
        } else if (substream === 2) {
            // toastr..success("Switched simulcast substream! (higher quality)", null, { timeOut: 2000 });
            $('#sl-2').removeClass('btn-primary btn-info btn-success').addClass('btn-success');
            $('#sl-1').removeClass('btn-primary btn-success').addClass('btn-primary');
            $('#sl-0').removeClass('btn-primary btn-success').addClass('btn-primary');
        }
        // Check the temporal layer
        if (temporal === 0) {
            // toastr..success("Capped simulcast temporal layer! (lowest FPS)", null, { timeOut: 2000 });
            $('#tl-2').removeClass('btn-primary btn-success').addClass('btn-primary');
            $('#tl-1').removeClass('btn-primary btn-success').addClass('btn-primary');
            $('#tl-0').removeClass('btn-primary btn-info btn-success').addClass('btn-success');
        } else if (temporal === 1) {
            // toastr..success("Capped simulcast temporal layer! (medium FPS)", null, { timeOut: 2000 });
            $('#tl-2').removeClass('btn-primary btn-success').addClass('btn-primary');
            $('#tl-1').removeClass('btn-primary btn-info btn-success').addClass('btn-success');
            $('#tl-0').removeClass('btn-primary btn-success').addClass('btn-primary');
        } else if (temporal === 2) {
            // toastr..success("Capped simulcast temporal layer! (highest FPS)", null, { timeOut: 2000 });
            $('#tl-2').removeClass('btn-primary btn-info btn-success').addClass('btn-success');
            $('#tl-1').removeClass('btn-primary btn-success').addClass('btn-primary');
            $('#tl-0').removeClass('btn-primary btn-success').addClass('btn-primary');
        }
    }


    const mediaState = () => { }
    const webrtcState = () => { }
    const onmessage = () => { }
    const onlocalstream = () => { }
    const onremotestream = () => { }
    const onlocaltrack = () => { }
    const onremotetrack = () => { }
    Janus.init({
        debug: true, callback: function () {
            // Use a button to start the demo
            $(this).attr('disabled', true).unbind('click');
            // Make sure the browser supports WebRTC
            if (!Janus.isWebrtcSupported()) {
                //bootbox.alert("No WebRTC support... ");
                return;
            }
            // Create session
            janus = new Janus(
                {
                    server: server,
                    iceServers: iceServers,
                    // Should the Janus API require authentication, you can specify either the API secret or user token here too
                    //		token: "mytoken",
                    //	or
                    //		apisecret: "serversecret",
                    success: function () {
                        // Attach to VideoCall plugin
                        janus.attach(
                            {
                                plugin: "janus.plugin.videocall",
                                opaqueId: opaqueId,
                                success: function (pluginHandle) {
                                    $('#details').remove();
                                    videocall = pluginHandle;
                                    registerUsername(registerId);
                                    Janus.log("Plugin attached! Video (" + videocall.getPlugin() + ", id=" + videocall.getId() + ")");
                                    // Prepare the username registration
                                    $('#videocall').removeClass('hide').show();
                                    $('#login').removeClass('hide').show();
                                    $('#registernow').removeClass('hide').show();
                                    $('#register').click(registerUsername);

                                    $('#username').focus();
                                    $('#start').removeAttr('disabled').html("Stop")
                                        .click(function () {
                                            $(this).attr('disabled', true);
                                            janus.destroy();
                                        });
                                },
                                error: function (error) {
                                    Janus.error("  -- Error attaching plugin...", error);
                                    //bootbox.alert("  -- Error attaching plugin... " + error);
                                },
                                consentDialog: function (on) {

                                    Janus.debug("Consent dialog should be " + (on ? "on" : "off") + " now");
                                    console.log(on)

                                },
                                iceState: function (state) {
                                    Janus.log("ICE state changed to " + state);
                                },
                                mediaState: function (medium, on, mid) {
                                    Janus.log("Janus " + (on ? "started" : "stopped") + " receiving our " + medium + " (mid=" + mid + ")");
                                },
                                webrtcState: function (on) {
                                    Janus.log("Janus says our WebRTC PeerConnection is " + (on ? "up" : "down") + " now");
                                    // $("#videoleft").parent().unblock();
                                },
                                slowLink: function (uplink, lost, mid) {
                                    Janus.warn("Janus reports problems " + (uplink ? "sending" : "receiving") +
                                        " packets on mid " + mid + " (" + lost + " lost packets)");
                                },
                                onmessage: async function (msg, jsep) {
                                    jsepp = jsep
                                    Janus.debug(" ::: Got a message :::", msg);
                                    let result = msg["result"];
                                    if (result) {
                                        if (result["list"]) {
                                            let list = result["list"];
                                            Janus.debug("Got a list of registered peers:", list);
                                            for (let mp in list) {
                                                Janus.debug("  >> [" + list[mp] + "]");
                                            }
                                        } else if (result["event"]) {
                                            let event = result["event"];
                                            if (event === 'registered') {
                                                myusername = escapeXmlTags(result["username"]);
                                                Janus.log("Successfully registered as " + myusername + "!");
                                                $('#youok').removeClass('hide').show().html("Registered as '" + myusername + "'");
                                                // Get a list of available peers, just for fun
                                                videocall.send({ message: { request: "list" } });
                                                // Enable buttons to call now
                                                $('#phone').removeClass('hide').show();
                                                $('#call').unbind('click').click(doCall);
                                                $('#peer').focus();
                                            } else if (event === 'calling') {
                                                Janus.log("Waiting for the peer to answer...");
                                                // TODO Any ringtone?
                                                //bootbox.alert("Waiting for the peer to answer...");
                                            } else if (event === 'incomingcall') {
                                                Janus.log("Incoming call from " + result["username"] + "!");

                                                yourusername = escapeXmlTags(result["username"]);
                                                const info_user = await getInfoUser(result['username']);
                                                dispatch(slice.actions.statusIncomingVideoCall(info_user));
                                            } else if (event === 'accepted') {
                                                //bootbox.hideAll();
                                                let peer = escapeXmlTags(result["username"]);
                                                if (!peer) {
                                                    Janus.log("Call started!");
                                                } else {
                                                    Janus.log(peer + " accepted the call!");
                                                    yourusername = peer;
                                                }
                                                // Video call can start
                                                if (jsep)
                                                    videocall.handleRemoteJsep({ jsep: jsep });
                                                videocall.send({ message: { request: "set", audio: true, videocall: true } });

                                                $('#call').removeAttr('disabled').html('Hangup')
                                                    .removeClass("btn-success").addClass("btn-danger")
                                                    .unbind('click').click(doHangup);
                                                videocall.send({ message: { request: "set", audio: true, videocall: true } });

                                            } else if (event === 'update') {
                                                // An 'update' event may be used to provide renegotiation attempts
                                                if (jsep) {
                                                    if (jsep.type === "answer") {
                                                        videocall.handleRemoteJsep({ jsep: jsep });
                                                    } else {
                                                        videocall.createAnswer(
                                                            {
                                                                jsep: jsep,
                                                                // We want bidirectional audio and video, if offered,
                                                                // plus data channels too if they were negotiated
                                                                tracks: [
                                                                    { type: 'audio', capture: true, recv: true },
                                                                    { type: 'video', capture: true, recv: true },
                                                                    { type: 'data' },
                                                                ],
                                                                success: function (jsep) {
                                                                    Janus.debug("Got SDP!", jsep);
                                                                    let body = { request: "set" };
                                                                    videocall.send({ message: body, jsep: jsep });
                                                                },
                                                                error: function (error) {
                                                                    Janus.error("WebRTC error:", error);
                                                                    //bootbox.alert("WebRTC error... " + error.message);
                                                                }
                                                            });
                                                    }
                                                }
                                            } else if (event === 'hangup') {
                                                Janus.log("Call hung up by " + result["username"] + " (" + result["reason"] + ")!");
                                                videocall.hangup();
                                                if (spinner)
                                                    spinner.stop();
                                                $('#waitingvideo').remove();
                                                $('#videos').hide();
                                                $('#peer').removeAttr('disabled').val('');
                                                $('#call').removeAttr('disabled').html('Call')
                                                    .removeClass("btn-danger").addClass("btn-success")
                                                    .unbind('click').click(doCall);
                                                $('#toggleaudio').attr('disabled', true);
                                                $('#togglevideo').attr('disabled', true);
                                                $('#bitrate').attr('disabled', true);
                                                $('#curbitrate').hide();
                                                $('#curres').hide();
                                                dispatch(slice.actions.statusHangup());
                                            } else if (event === "simulcast") {

                                                // Is simulcast in place?
                                                let substream = result["substream"];
                                                let temporal = result["temporal"];
                                                if ((substream !== null && substream !== undefined) || (temporal !== null && temporal !== undefined)) {
                                                    if (!simulcastStarted) {
                                                        simulcastStarted = true;
                                                        addSimulcastButtons(result["videocodec"] === "vp8");
                                                    }
                                                    // We just received notice that there's been a switch, update the buttons
                                                    updateSimulcastButtons(substream, temporal);
                                                }
                                            }
                                        }
                                    } else {
                                        // FIXME Error?
                                        let error = msg["error"];
                                        console.log(error)
                                        //bootbox.alert(error);

                                        if (error.indexOf("already taken") > 0) {
                                            // FIXME Use status codes...
                                            $('#username').removeAttr('disabled').val("");
                                            $('#register').removeAttr('disabled').unbind('click').click(registerUsername);
                                        }
                                        // TODO Reset status
                                        videocall.hangup();

                                        if (spinner)
                                            spinner.stop();
                                        $('#waitingvideo').remove();
                                        $('#videos').hide();
                                        $('#peer').removeAttr('disabled').val('');
                                        $('#call').removeAttr('disabled').html('Call')
                                            .removeClass("btn-danger").addClass("btn-success")
                                            .unbind('click').click(doCall);
                                        $('#toggleaudio').attr('disabled', true);
                                        $('#togglevideo').attr('disabled', true);
                                        $('#bitrate').attr('disabled', true);
                                        $('#curbitrate').hide();
                                        $('#curres').hide();
                                        if (bitrateTimer)
                                            clearInterval(bitrateTimer);
                                        bitrateTimer = null;
                                        dispatch(slice.actions.statusError({ msgError: error }));
                                    }
                                },
                                onlocaltrack: function (track, on) {
                                    Janus.log("123");
                                    Janus.log(on);
                                    Janus.debug("Local track " + (on ? "added" : "removed") + ":", track);
                                    let trackId = track.id.replace(/[{}]/g, "");
                                    if (track.kind === "audio") { }
                                    else {
                                        let stream = new MediaStream([track]);
                                        localVideos++;
                                        stream = new MediaStream([track]);
                                        $('#is_connect_video_left').css('display', "none");
                                        $('#myvideo').css('display', "block");
                                        localTracks[trackId] = stream;
                                        Janus.log("Created local stream:", stream);
                                        Janus.attachMediaStream($('#myvideo').get(0), stream);
                                    }
                                    if (videocall.webrtcStuff.pc.iceConnectionState !== "completed" &&
                                        videocall.webrtcStuff.pc.iceConnectionState !== "connected") {

                                    }
                                },
                                onremotetrack: function (track, mid, on, metadata) {
                                    Janus.debug(
										"Remote track (mid=" + mid + ") " +
										(on ? "added" : "removed") +
										(metadata ? " (" + metadata.reason + ") ": "") + ":", track
									);
									if(!on) {
										// Track removed, get rid of the stream and the rendering
										$('#peervideo' + mid).remove();
										if(track.kind === "video") {
											remoteVideos--;
											if(remoteVideos === 0) {
												// No video, at least for now: show a placeholder
												if($('#videoright .no-video-container').length === 0) {
													$('#videoright').append(
														'<div class="no-video-container">' +
															'<i class="fa-solid fa-video fa-xl no-video-icon"></i>' +
															'<span class="no-video-text">No remote video available</span>' +
														'</div>');
												}
											}
										}
										delete remoteTracks[mid];
										return;
									}
									if($('#peervideo' + mid).length > 0)
										return;
									// If we're here, a new track was added
									$('#spinner').remove();
									let addButtons = false;
									if($('#videoright audio').length === 0 && $('#videoright video').length === 0) {
										addButtons = true;
										$('#videos').removeClass('hide');
									}
									if(track.kind === "audio") {
										// New audio track: create a stream out of it, and use a hidden <audio> element
										let stream = new MediaStream([track]);
										remoteTracks[mid] = stream;
										Janus.log("Created remote audio stream:", stream);
										$('#videoright').append('<audio class="hide" id="peervideo' + mid + '" autoplay playsinline/>');
										Janus.attachMediaStream($('#peervideo' + mid).get(0), stream);
										if(remoteVideos === 0) {
											// No video, at least for now: show a placeholder
											if($('#videoright .no-video-container').length === 0) {
												$('#videoright').append(
													'<div class="no-video-container">' +
														'<i class="fa-solid fa-video fa-xl no-video-icon"></i>' +
														'<span class="no-video-text">No webcam available</span>' +
													'</div>');
											}
										}
									} else {
										// New video track: create a stream out of it
										remoteVideos++;
										$('#videoright .no-video-container').remove();
										let stream = new MediaStream([track]);
										remoteTracks[mid] = stream;
                                        $('#is_connect_video_right').css('display', "none");
										Janus.log("Created remote video stream:", stream);
										$('#videoright').append('<video class="rounded centered" id="peervideo' + mid + '" width="100%" height="100%" autoplay playsinline/>');
										Janus.attachMediaStream($('#peervideo' + mid).get(0), stream);
										// Note: we'll need this for additional videos too
										if(!bitrateTimer) {
											$('#curbitrate').removeClass('hide');
											bitrateTimer = setInterval(function() {
												if(!$("#peervideo" + mid).get(0))
													return;
												// Display updated bitrate, if supported
												let bitrate = videocall.getBitrate();
												//~ Janus.debug("Current bitrate is " + videocall.getBitrate());
												$('#curbitrate').text(bitrate);
												// Check if the resolution changed too
												let width = $("#peervideo" + mid).get(0).videoWidth;
												let height = $("#peervideo" + mid).get(0).videoHeight;
												if(width > 0 && height > 0)
													$('#curres').removeClass('hide').text(width+'x'+height).removeClass('hide');
											}, 1000);
										}
									}
									if(!addButtons)
										return;
									// Enable audio/video buttons and bitrate limiter
									audioenabled = true;
									videoenabled = true;
									$('#toggleaudio').removeAttr('disabled').click(
										function() {
											audioenabled = !audioenabled;
											if(audioenabled)
												$('#toggleaudio').html("Disable audio").removeClass("btn-success").addClass("btn-danger");
											else
												$('#toggleaudio').html("Enable audio").removeClass("btn-danger").addClass("btn-success");
											videocall.send({ message: { request: "set", audio: audioenabled }});
										});
									$('#togglevideo').removeAttr('disabled').click(
										function() {
											videoenabled = !videoenabled;
											if(videoenabled)
												$('#togglevideo').html("Disable video").removeClass("btn-success").addClass("btn-danger");
											else
												$('#togglevideo').html("Enable video").removeClass("btn-danger").addClass("btn-success");
											videocall.send({ message: { request: "set", video: videoenabled }});
										});
									$('#toggleaudio').parent().removeClass('hide');
									$('#bitrate a').removeAttr('disabled').click(function() {
										$('.dropdown-toggle').dropdown('hide');
										let id = $(this).attr("id");
										let bitrate = parseInt(id)*1000;
										if(bitrate === 0) {
											Janus.log("Not limiting bandwidth via REMB");
										} else {
											Janus.log("Capping bandwidth to " + bitrate + " via REMB");
										}
										$('#bitrateset').text($(this).text()).parent().removeClass('open');
										videocall.send({ message: { request: "set", bitrate: bitrate }});
										return false;
									});

                                }
                            });
                    },
                    error: function (error) {
                        Janus.error(error);
                        // bootbox.alert(error, function () {
                        //     window.location.reload();
                        // });
                    },
                    destroyed: function () {
                        window.location.reload();
                    }
                });
        }
    });
    dispatch(slice.actions.initializeJanus({ doCall: doCall, doHangup: doHangup, registerUsername: registerUsername, doAnswer: doAnswer, toggleMute: toggleMute, doCloseCall: doCloseCall, doShareScreen: doShareScreen, toggleVideo: toggleVideo }));
};

